import axios from "axios";
import { interceptor } from "./helper/middleware";

const formDataClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 300000,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("user_access_token")}`,
  },
});

interceptor(formDataClient);

export default formDataClient;
